import { Navigate, Route, Routes } from 'react-router'
import { AuditPage } from './pages/audit'
import { CasesPage } from './pages/cases'
import { CommunityPage } from './pages/community'
import { DashboardPage } from './pages/dashboard'
import { FactoriesPage } from './pages/factories'
import { ExpertReviewDetailPage } from './pages/expert-review-detail'
import { ExpertReviewsPage } from './pages/expert-reviews'
import { GoldenSetPage } from './pages/golden-set'
import { NotifyPage } from './pages/notify'
import { PricesPage } from './pages/prices'
import { QuoteDetailPage } from './pages/quote-detail'
import { QuotesPage } from './pages/quotes'
import { ReportsPage } from './pages/reports'
import { SettingsPage } from './pages/settings'
import { SimulationsPage } from './pages/simulations'
import { UsersPage } from './pages/users'
import { ManufacturingPage } from './pages/manufacturing'
import { AccessGrantsPage } from './pages/access-grants'
import { AdsPage } from './pages/ads'
import { useAdminAccess } from './lib/admin-access'
import { SamplesPage } from './pages/samples'

export function AppRoutes() {
  // 배정 운영자는 견적 화면에서 시작한다 (대시보드는 전체 숫자라 최고 관리자만)
  const home = useAdminAccess().level === 'operator' ? '/quotes' : '/dashboard'
  return (
    <Routes>
      <Route path="/" element={<Navigate to={home} replace />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/quotes" element={<QuotesPage />} />
      <Route path="/manufacturing" element={<ManufacturingPage />} />
      <Route path="/samples" element={<SamplesPage />} />
      <Route path="/quotes/:id" element={<QuoteDetailPage />} />
      <Route path="/factories" element={<FactoriesPage />} />
      <Route path="/expert-reviews" element={<ExpertReviewsPage />} />
      <Route path="/expert-reviews/:id" element={<ExpertReviewDetailPage />} />
      <Route path="/users" element={<UsersPage />} />
      <Route path="/notify" element={<NotifyPage />} />
      <Route path="/simulations" element={<SimulationsPage />} />
      <Route path="/community" element={<CommunityPage />} />
      <Route path="/reports" element={<ReportsPage />} />
      <Route path="/cases" element={<CasesPage />} />
      <Route path="/golden-set" element={<GoldenSetPage />} />
      <Route path="/prices" element={<PricesPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/audit" element={<AuditPage />} />
      <Route path="/access-grants" element={<AccessGrantsPage />} />
      <Route path="/ads" element={<AdsPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
